module.exports = "<section>\r\n    <p>{{title}}</p>\r\n    <ul>\r\n        <li *ngFor=\"let item of items\">{{item}}</li>\r\n    </ul>\r\n</section>"